import { cellCfgAttrsBaseSchema, cellCfgBaseSchema } from './cell-base.zod';
import z from 'zod';
import { baseComparisonSchema, baseOperandSchema, varConditionSchema } from '../conditional.zod';
import { ProcessProcessStatusEnum } from '../../../../db';
import { generatedAppletVariableCfgSchema } from '../var.zod';

const processOperandSchema = baseOperandSchema.extend({
    type: z.literal('processId'),
    processId: z.string(),
});

const processStatusOperandSchema = baseOperandSchema.extend({
    type: z.literal('processStatus'),
    expectedStatus: z.enum([
        ProcessProcessStatusEnum.Completed,
        ProcessProcessStatusEnum.Incomplete,
    ]),
});

const materialFilterComparisonSchema = baseComparisonSchema.extend({
    type: z.literal('processStatus'),
    operands: z.tuple([
        processOperandSchema,
        processStatusOperandSchema,
    ]),
});

// throwing variable id and variable config into the same object since we are only going to reference one variable at a time WRT macro outputs it doesnt make sense to make each one a record shape
const macroOutputVariable = z.object({
    varId: z.string().min(1),
    varCfg: generatedAppletVariableCfgSchema,
});

export const materialLookupAttrsSchema = cellCfgAttrsBaseSchema.extend({
    matClassId: z.string(),
    /** when empty, all material models are included */
    matModelIds: z.array(z.string()).default([]),
    /**
     * when a material result is selected, data will be saved to these local vars
     */
    outputVars: z.object({
        materialIdVar: macroOutputVariable,
        serialNumberVar: macroOutputVariable,
        udfs: z.array(z.object({
            udfColumnId: z.string(),
            varCfg: macroOutputVariable,
        })),
    }),
    udfColsToShow: z.array(z.object({
        udfColumnId: z.string(),
        udfName: z.string(),
    })),
    /**
     * all these get ANDed together
     */
    filterConditions: z.array(z.object({
        boolOperation: z.enum([ 'and', 'or' ]),
        comparisons: z.array(materialFilterComparisonSchema),
        evalTrigger: z.enum([ 'event', 'varChange' ]).default('varChange'),
        eventTrigger: z.string().optional(),
    })),
    /**
     * the cell will initially perform its query as soon as it can.
     * this condition controls when it re-runs the query.
    */
    refreshCondition: varConditionSchema,
});

export const materialLookupCellSchema = cellCfgBaseSchema.extend({
    type: z.literal('materialLookup'),
    attrs: materialLookupAttrsSchema,
});
